import { Grid, Typography, Tooltip } from '@mui/material'
import { currencyMask } from '../../../../utils/masks'
import { useCheckout } from './CheckoutContext'
import CardTable from '../../../../components/CardTable'

const nomeCell = ({ linhaOriginal }) => (
  <Grid container>
    <Grid item xs={12}>
      <Tooltip title={linhaOriginal?.dsProduto}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {linhaOriginal?.dsProduto}
        </Typography>
      </Tooltip>
    </Grid>
    <Grid item xs={12}>
      <Typography variant="caption" sx={{ color: 'text.disabled' }}>
        {linhaOriginal.qtProduto}X R$:{' '}
        {currencyMask(linhaOriginal?.vlUnitarioInicial || 0)}
      </Typography>
    </Grid>
  </Grid>
)

const ESTILO_COL = [
  { width: '70%', truncate: true },
  { width: '30%', textAlign: 'right' },
]

const PagosCard = ({ titulo, lista, preencherAltura }) => (
  <CardTable
    titulo={titulo}
    dadosTabela={lista}
    maxLinhas={7}
    preencherAltura={preencherAltura}
    alturaMinimaLinha={0}
    compactarLinhas
    colunas={['Nome', 'Valor']}
    mapear={(item) => [item.dsProduto, item.vlTotal]}
    colunasMoeda={[1]}
    estiloColunas={ESTILO_COL}
    opcoesColuna={[{ alias: 0, customJsx: nomeCell }]}
    colunasTotal={[1]}
    rotuloTotal="Total"
    semBordas
  />
)

export const TerapiasPagasCard = ({ preencherAltura }) => {
  const { terapiasPagas } = useCheckout()
  return (
    <PagosCard
      preencherAltura={preencherAltura}
      titulo="Terapias Pagas"
      lista={terapiasPagas}
    />
  )
}

export const ProdutosPagosCard = ({ preencherAltura }) => {
  const { produtosPagos } = useCheckout()
  return (
    <PagosCard
      preencherAltura={preencherAltura}
      titulo="Produtos Pagos"
      lista={produtosPagos}
    />
  )
}
